import { IpCan } from './IpCan';

export default class IpCanLPMatrixDisplayV2 extends IpCan {}
